module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-cta-banner-1920x515-a4dc1f2315692f61f64061b59016c373.jpg";